<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="addComboConfig.isOpen"
    id="add-sidebar"
  >
    <div class="flex items-center justify-between px-6 pb-2">
      <h4 class="font-bold text-2xl">Add New Combo</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebarCombo" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="sidebar-content p-6 overflow-auto add-service-form">

        <h4 class="font-bold text-lg mb-3">Combo name</h4>
        <vs-input placeholder="Combo Name" v-validate="'required'" name="name" v-model="name" class="w-full" :danger="errors.has('name')"
              danger-text="The combo name field is required"/>

        <h4 class="font-bold text-lg mb-3 mt-4">Combo description</h4>
        <vs-textarea v-model="note" height="70"/>

        <h4 class="font-bold text-lg mb-4">Add item</h4>
        <vs-button style="min-width: 80px" class="mb-4" @click="addItem">+ Add item</vs-button>
        <div v-if="newList.length > 0">
          <div class="" v-for="(item , index) in newList" :key="index">
            <div class="flex">
              <div class="w-5/12 px-2">
                <p class="product-name font-medium truncate service-name" :style="`color: ${item.color_code}`">{{item.name}}</p>
              </div>
              <div class="w-1/6 px-2">
                <div v-if="item.price != null">
                  <p class="product-name font-medium truncate text-center">${{item.price}}</p>
                </div>
                <div v-else>
                  <p class="product-name font-medium truncate text-center">N/A</p>
                </div>
              </div>
              <div class="w-1/4 flex align-center">
                <span class="mt-2">$</span>
                <vs-input @input="changePrice($event,index)" class="w-1/2 mt-2 add-combo-price-item" v-model="item.price" :maxlength="5" v-if="item.price != null" v-on:keypress="isNumber($event)"></vs-input>
              </div>
              <div class="w-2/12 px-2">
                <img src="../../assets/images/trash-icon.png" class="mt-4 ml-4 trash-icon" @click.stop="removeItem(item)" />
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="w-5/12 px-2">
              <p class="product-name font-medium truncate service-name">Combo price</p>
            </div>
            <div class="w-1/6 px-2">
              <p class="product-name font-medium truncate text-center">${{combo_price}}</p>
            </div>
          </div>
        </div>

        <h4 class="font-bold text-lg mb-4">Category name</h4>
        <v-select @input="selectId($event)" label="name" :options="serviceData" v-model="cateId" class="w-full" disabled :clearable="false" :searchable="false"></v-select>

        <h4 class="font-bold text-lg mb-6 mt-4">Online booking visibility</h4>
        <div class="flex align-center"><vs-checkbox class="m-0 mr-2" v-model="status">Service visible to client during online booking.</vs-checkbox></div>
        <p class="text-grey-custom" style="font-size: 12px">When enabled, this service will appear in your Booking Site and Embedded Widgets. This will not affect your ability to choose it when you create an appointment.</p>
        <p v-if="config.service_distinction">
        <vs-checkbox class="m-0 mr-2 mb-6" v-model="gocheckin_available">Service available on GoCheckin.</vs-checkbox>
        </p>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" style="min-width: 140px" @click="addCombo">Submit</vs-button>
      <vs-button type="border" color="danger"  @click.stop="closeSidebarCombo" style="min-width: 140px">Cancel</vs-button>
    </div>

    <popup-add-item :popupAddItem="popupAddItem" :listItemAdded="newList" @ConfirmList="confirmList" @ClosePopup="closePopup" :key="add_item_key"></popup-add-item>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: "vs-add-combo",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    'v-select': vSelect,
  },
  props: {
    addComboConfig: {
      type: Object,
      required: true
    },
    serviceData: {
      type: Array,
      required: false
    },
    activeServiceData: {
      type: Object,
      required: true
    },
    activeStaffData: {
      type: Object,
      required: true,
    }
  },
  data(){
    return {
      name : "",
      note : "",
      status: true,
      cateId: this.activeStaffData ? this.activeStaffData.name : "",
      selectedId: this.activeStaffData ? this.activeStaffData.id : "",
      distinctionValue: {name: "Show on GoCheckin & GoBooking", value: 0, },
      gocheckin_available: true,
      gobooking_available: true,
      popupAddItem: {
        isOpen: false
      },
      listItemAdded: [],
      combo_price: 0,
      total_duration: 0,
      newList: [],
      add_item_key: 0
    }
  },
  watch: {
    listItemAdded: {
      immediate: true,
      deep: true,
      handler() {
        if(this.listItemAdded) {
          this.newList = [];
          for(let i = 0; i<this.listItemAdded.length; i++){
            let item = {};
            for (var key in this.listItemAdded[i]) {
              item[key] = this.listItemAdded[i][key];
            }
            this.newList.push(item)
          }
        }
        this.getTotal();
      }
    }
  },
  methods: {
    addItem(){
      this.popupAddItem.isOpen = true;
      this.add_item_key++;
    },
    closeSidebarCombo(){
      this.$emit("CloseSidebarCombo")
    },
    confirmList(data){
      this.listItemAdded = data;
      this.popupAddItem.isOpen = false;
      this.getTotal()
    },
    getTotal(){
      let total = 0;
      let duration = 0;
      if(this.newList.length > 0){
        for(let i = 0; i<this.newList.length; i++){
          if(this.newList[i].price != null){
            total = parseFloat(total) + parseFloat(this.newList[i].price);
          }
          duration = duration + this.newList[i].duration
        }
      }
      this.combo_price = total;
      this.total_duration = duration;
    },
    closePopup(){
      this.popupAddItem.isOpen = false;
    },
    removeItem(item){
      if(this.newList.length > 0){
        for(let i = 0; i<this.newList.length; i++){
          if(this.newList[i].id == item.id){
            this.newList.splice(i, 1)
          }
        }
      }
      this.getTotal();
      this.add_item_key++;
    },
    addCombo(){
      if(this.name != ''){
        const obj = {
          category_id: this.selectedId,
          name: this.name,
          description: this.note,
          price: this.combo_price,
          duration: this.total_duration,
          status: 1,
          combo_items: []
        }
        for(let i = 0; i<this.newList.length; i++){
          const data = {
            item_price: parseFloat(this.newList[i].price),
            item_id: this.newList[i].id,
            item_type: "service",
            priority: this.newList[i].priority,
            item_data: [],
            status: this.newList[i].status
          }
          obj.combo_items.push(data)
        }
        if(this.newList.length == 0){
          this.$vs.notify({
            title:'Notification',
            text:'This combo must have at least one service!',
            color:'danger',
            position:'top-right'})
        }else{
          this.$emit("AddCombo", obj)
        }
      }
      this.$validator.validateAll();
    },
    changePrice(event, index){
      if (event != "") {
        this.newList[index].price = (event);
      } else {
        this.newList[index].price = 0;
      }
      // if(this.newList[index].price == 0 || this.newList[index].price == ''){
      //   this.newList[index].price = event
      // }
      this.getTotal();
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.input_price.indexOf(".") != -1)) {
          evt.preventDefault();
      } else {
          return true;
      }
    },
  },
  computed: {
    config(){
      return this.$store.getters['auth/config'];
    },
  },
}
</script>

<style scoped>
.trash-icon {
    width: 15px;
    height: 18.89px;
}
.add-combo-price-item input{
  padding: 0px;
  border-radius: 0px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
</style>


